import http from "../core/http";
const group = 'myVessels';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const findDataRequest =  async (data) => {
    return await http.post(`${group}/find`, data).then(res => res.data).catch(http.defaultCatch);
}

export const requestVesselDeletion =  async (data) => {
    return await http.post(`${group}/requestDeletion`, data).then(res => res.data).catch(http.defaultCatch);
}
export const requestPermitRequest =  async (data) => {
    return await http.post(`${group}/requestPermit`, data).then(res => res.data).catch(http.defaultCatch);
}
export const cancelPermitRequest =  async (data) => {
    return await http.post(`${group}/cancelPermit`, data).then(res => res.data).catch(http.defaultCatch);
}
export const triggerPaymentRequest =  async (data) => {
    return await http.post(`${group}/triggerPayment`, data).then(res => res.data).catch(http.defaultCatch);
}
export const requestForDocking =  async (data) => {
    return await http.post(`${group}/requestForDocking`, data).then(res => res.data).catch(http.defaultCatch);
}
export const cancelDockingRequest =  async (data) => {
    return await http.post(`${group}/cancelDockingRequest`, data).then(res => res.data).catch(http.defaultCatch);
}
export const payAndComplete =  async (data) => {
    return await http.post(`${group}/payAndComplete`, data).then(res => res.data).catch(http.defaultCatch);
}


export const requestVesselAccess =  async (data) => {
    return await http.post(`${group}/requestVesselAccess`, data).then(res => res.data).catch(http.defaultCatch);
}
export const approveVesselAccess =  async (data) => {
    return await http.post(`${group}/approveVesselAccess`, data).then(res => res.data).catch(http.defaultCatch);
}
export const leaveVessel =  async (data) => {
    return await http.post(`${group}/leaveVessel`, data).then(res => res.data).catch(http.defaultCatch);
}
export const rejectVesselAccess =  async (data) => {
    return await http.post(`${group}/rejectVesselAccess`, data).then(res => res.data).catch(http.defaultCatch);
}
export const activateVessel =  async (data) => {
    return await http.post(`${group}/activateVessel`, data).then(res => res.data).catch(http.defaultCatch);
}
export const deactivateVessel =  async (data) => {
    return await http.post(`${group}/deactivateVessel`, data).then(res => res.data).catch(http.defaultCatch);
}



export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getVesselTypeListRequest =  async (data) => {
	return await http.post(`${group}/getVesselTypeList`, data).then(res => res.data).catch(http.defaultCatch);
}

export const resubmitVesselRequest = async (data) => {
    return await http.post(`${group}/resubmit`, data).then(res => res.data).catch(http.defaultCatch);
}

export const reschedulePermitRequest = async (data) => {
    return await http.post(`${group}/reschedulePermit`, data).then(res => res.data).catch(http.defaultCatch);
}
